import React from 'react';
import WidgetMachinesSection from 'components/quote_builder_widget/sections/WidgetMachinesSection';

const PRINTING_MACHINE_LABELS = {
  add: 'add_printing_machine',
  select: 'select_printing_machine',
  noneAdded: 'no_printing_machines_enabled',
  noWidgetMaterials: 'no_widget_materials_for_printing',
  noMachines: 'no_printing_machines',
  noMachinesForMaterials: 'no_printing_machines_for_materials',
  notUsed: 'printing_machine_not_used',
  failedToLoad: 'failed_to_load_printing_machines',
  failedToUpdate: 'failed_to_update_printing_machine',
  createNew: 'create_new_printing_machine',
  noAllowedTypes: 'no_widget_printing_types',
};

const PrintingMachinesSection = ({ onPrintingMachinesChange, onAddedCountChange }) => (
  <WidgetMachinesSection
    machineKey="printing_machine"
    listUrl="/quote-builder/widgets/printing-machines"
    listField="printing_machines"
    allowedTypesField="widget_printing_types"
    labels={PRINTING_MACHINE_LABELS}
    onMachinesChange={onPrintingMachinesChange}
    onAddedCountChange={onAddedCountChange}
  />
);

export default PrintingMachinesSection;
